import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `delayMs`, plus whether the debounce timer is
 * still pending (i.e. the debounced value hasn't caught up to the latest one yet).
 */
export const useDebouncedValue = <T>(value: T, delayMs: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return { debouncedValue, isPending: debouncedValue !== value };
};
